import React from "react";
import {Configure, InstantSearch} from "react-instantsearch-dom";
import algoliasearch from "algoliasearch/lite";
import {useSelector} from "react-redux";

const AlgoliaProvider = ({children, hitsPerPage = 1000000}) => {
    const searchClient = algoliasearch(
        process.env.REACT_APP_ALGOLIA_APP_ID,
        process.env.REACT_APP_ALGOLIA_APP_SEARCH_KEY
    );
    const company_id = useSelector(state => state.context?.company_id);
    if (company_id) {
        const indexName = process.env.REACT_APP_ALGOLIA_INDEX_PREFIX + company_id.toString();
        return (
            <InstantSearch searchClient={searchClient} indexName={indexName}>
                <Configure
                    advancedSyntax={true}
                    typoTolerance={false}
                    attributesToHighlight={["content.text"]}
                    highlightPreTag={'<span class="text-highlight">'}
                    highlightPostTag={"</span>"}
                    queryLanguages={["en", "es"]}
                    ignorePlurals={["en", "es"]}
                    hitsPerPage={hitsPerPage}
                    // facets={["*", "language_id"]}
                    // facetFilters={["language_id:1"]}
                />
                {children}
            </InstantSearch>
        );
    }
    return children;
};

export default AlgoliaProvider;
